import { Injectable } from '@angular/core';
import { ErrorHandlerService } from '@y42/error-handling';
import { AbstractFeatureGitService, getY42GitPath, Y42GitFolders } from '@y42/feature/git';
import { Y42MetadataGitModel } from '@y42/feature/json-schema';
import { GitQuery, GitService } from '@y42/git';
import { Y42FeatureType } from '@y42/json-schema';
import { VisualizationWidgetSettingsGitModel, VisualizationWidgetStoreModel } from './visualization-widget.model';

@Injectable({ providedIn: 'root' })
export class VisualizationWidgetGitService extends AbstractFeatureGitService<
  VisualizationWidgetStoreModel,
  Y42GitFolders.VisualizationWidget
> {
  constructor(
    protected readonly git: GitService,
    protected readonly gitQuery: GitQuery,
    protected readonly errorHandlerService: ErrorHandlerService,
  ) {
    super({
      gitQuery,
      git,
      errorHandlerService,
      name: Y42FeatureType.VisualizationWidget,
      basePath: getY42GitPath(Y42GitFolders.VisualizationWidget),
      hydrationDefinition: {
        1: {
          modelType: 'folder',
          models: {
            chart_type: {
              fileName: 'settings.json',
              property: 'chart_type',
            },
            settings: {
              fileName: 'settings.json',
              property: 'settings',
            },
            datasource_table_path: {
              fileName: 'settings.json',
              property: 'datasource_table_path',
            },
            filters: {
              fileName: 'settings.json',
              property: 'filters',
            },
            fields: {
              fileName: 'settings.json',
              property: 'fields',
            },
            extra_echarts_config: {
              fileName: 'settings.json',
              property: 'extra_echarts_config',
            },
          },
        },
      },
      models: {
        metadata: {
          fileName: 'metadata.json',
          model: Y42MetadataGitModel,
        },
        settings: {
          fileName: 'settings.json',
          model: VisualizationWidgetSettingsGitModel,
          serialize: true,
        },
      },
    });
  }
}
